<div
    class="cs-common-ui wf-diagram wf-automation--container cs-d-flex w-100 pos-rlt"
    *ngIf="nodes?.length"
    (mouseup)="enablePan && panning ? mouseUp($event) : true">
    <div class="wf-automation--zoom pos-abt pos-abt--topright" *ngIf="zoom">
        <div class="cs-d-flex flex-column cs-zoom-tool cs-border cs-border--all cs-box-shadow w-100">
            <button class="cs-border cs-border--bottom text-center cs-toolbox cursor-pointer btn btn-icon bg-white" style="font-size:12px" (click)="zoomReset()">1:1</button>
            <button class="cs-border cs-border--bottom text-center cs-toolbox cursor-pointer btn btn-icon bg-white" (click)="zoomIn()"><i class="fa-light fa-plus"></i></button>
            <button class="text-center cs-toolbox cursor-pointer btn btn-icon" (click)="zoomOut()"><i class="fa-light fa-minus"></i></button>
        </div>
    </div>
    <div
        (mousedown)="enablePan ? mouseDown($event) : true"
        (mousemove)="enablePan ? mouseMove($event) : true"
        class="pos-abt-full" style="background: #FBFBFB">
        <div [ngStyle]="{'transform': transformVal, 'cursor': cursorVal}"
            class="p-20 w-100 h-100xxx" [ngClass]="{ 'offsetTrans': transitionOn}">
            <ng-container *ngFor="let node of nodes; let i = index">
                <div class="wf-diagram-self-{{direction}}">
                    <app-node-view
                        [isNew]="isNew"
                        [nodeOptions]="nodeOptions"
                        [node]="node"
                        [dagSourceModel]="dagSourceModel"
                        [screenName]="screenName"
                        [direction]="direction"></app-node-view>
                </div>
            </ng-container>
        </div>
    </div>
</div>
